import { gql } from '@apollo/client';
import Category from './category';

export const Product = gql`
    fragment Product on ProductRecord {
        __typename
        title
        sku: akeneoCode
        categories {
            ...Category
        }
    }
    ${Category}
`;
